module.exports = __webpack_public_path__ + "media/images/triangle--down--rb-dark-blue-ba0ca024e4e0d43fbf7d71bce169e085.png";